// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
import { getAuth, GoogleAuthProvider } from "firebase/auth";

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyApWe-T9kprffJbUqlxNwZfefXWiXQav88",
    authDomain: "prepme-c8eda.firebaseapp.com",
    projectId: "prepme-c8eda",
    storageBucket: "prepme-c8eda.firebasestorage.app",
    messagingSenderId: "434137556021",
    appId: "1:434137556021:web:7960c3d11c0d9afa277d7c"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();